import { render, staticRenderFns } from "./allot.vue?vue&type=template&id=fe3738c4&scoped=true"
import script from "./allot.vue?vue&type=script&lang=js"
export * from "./allot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3738c4",
  null
  
)

export default component.exports